import type { AnyAction } from "@reduxjs/toolkit";

import {
  getErrorDetails,
  getToastCtaForErrorDetails,
} from "@editor/utils/error-handling";

import { createSlice } from "@reduxjs/toolkit";
import toast from "@replo/design-system/components/alert/Toast";

/**
 * This can be used to extract usage data from a billing plan exception if it
 * exists.
 */
export const getBillingPlanErrorUsage = (
  action: AnyAction,
):
  | {
      maximum: number;
      current: number;
    }
  | undefined => {
  const usage =
    action.payload?.response?.usage ??
    action.payload?.data?.usage ??
    action.payload?.details?.errorDetails?.usage;

  return usage
    ? {
        maximum: usage.maximum ?? Number.POSITIVE_INFINITY,
        current: usage.current,
      }
    : undefined;
};
/**
 * A slice for any errors and exceptions
 */
const errorSlice = createSlice({
  name: "error",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* If you define a next, automatically redirect after an API call is successful */
      .addMatcher(
        (action: AnyAction) => {
          return (
            Boolean(action.type?.endsWith("_ERROR")) ||
            Boolean(action.type?.endsWith("/rejected"))
          );
        },
        (_state, action) => {
          const details = getErrorDetails({
            type: "rsaaOrRtkQueryAction",
            action,
          });

          if (details && details.type === "toast") {
            const cta = getToastCtaForErrorDetails(details.errorDetails);
            if (cta) {
              toast({
                type: "error",
                ...details.errorDetails,
                ...cta,
              });
            } else {
              toast({
                type: "error",
                ...details.errorDetails,
              });
            }
          }
        },
      );
  },
});

const { reducer } = errorSlice;

export default reducer;
